module.exports = __webpack_public_path__ + "static/img/product4.ccb90dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product4.jpg
// module id = cAu6
// module chunks = 0